import config from "./config";
import store from "./store";

const api = {
	serverUrl: config.server.make( "/" ),

	path2url( path ) {
		return /^[a-z]{2,5}:\/\//i.test( path ) ? path : this.serverUrl.replace( /\/+$/g, "" ) + "/" + path.replace( /^\/+/g, "" );
	},
	
	url( path, params ) {
		if ( !Array.isArray( params ) ) params = [ params ];
		return params.reduce( ( a, p ) => a + "/" + encodeURIComponent( p ), this.path2url( path ) );
	},
	
	async rq( defMethod, defAccept, defRet, url, data, opts, cache, urlPreprocess ) {
		if ( !opts ) opts = {};

		if ( !defMethod ) defMethod = "GET";
		if ( !defAccept ) defAccept = "application/json, text/plain, */*";
		defRet = defRet ? defRet.toLowerCase() : "text";
		
		if ( !("method" in opts) ) opts.method = defMethod;
		if ( !("headers" in opts) ) opts.headers = {};

		//if ( !("Content-Type" in opts.headers) ) opts.headers["Content-Type"] = "application/json;charset=utf-8";
		if ( !( "Accept" in opts.headers ) ) opts.headers["Accept"] = defAccept;
		
		const method = opts.method.toUpperCase();
		opts.method = method;
		
		//opts.headers.Authorization = this.$store.state.user.token;
		
		if ( cache === false ) {
			opts.headers.Pragma = "no-cache";
			opts.headers["Cache-Control"] = "no-cache";
		}
		
		//force to transfer cookies with CORS
		if ( !opts.credentials ) opts.credentials = "include";

		let notify = true;
		if ( "notify" in opts ) {
			notify = !!opts.notify;
			delete opts.notify;
		}

		if ( data !== undefined ) {
			if ( method == "GET" ) {
				let q = "";
				for ( const i in data ) {
					if ( data.hasOwnProperty( i ) ) {
						q += "&" + encodeURIComponent( i ) + "=" + encodeURIComponent( data[i] );
					}
				}
				url += "?" + q;
			}
			else opts.body = opts.dataRaw ? data : JSON.stringify( data );
		}

		if ( Array.isArray( url ) ) url = url.reduce( ( a, i ) => a + ( Array.isArray( i ) ? encodeURIComponent( i ) : i ), "" );

		let res = null;
		try {
			res = await fetch( urlPreprocess ? urlPreprocess( url ) : this.path2url( url ) , opts );
		}
		catch ( e ) {
			res = {
				isAborted: e.name == "AbortError",
				status: 500,
				text: async () => {
					return e.message;
				}
			};
		}

		if ( res.status !== 200 ) {
			const app = window.app;
			
			if ( !url.includes( "logout" ) ) {
				if ( app && app.$store && app.$router ) {
					if ( res.status === 401 ) {
						try { await app.$store.dispatch( "user/logout" ) } catch ( e ) {}
						app.$router.go( app.$router.currentRoute );
					}
					
					if ( res.status === 403 ) {
						const cpURL = window.location.href;
						app.$router.replace( { name: "protected", query: { err: res.statusText } } );
						history.replaceState( {}, "Ошибка", cpURL );
						
						try { await app.$store.dispatch( "user/logout" ) } catch ( e ) {}
		
		//				window.location = "/protected?err=" + encodeURIComponent( res.statusText )
					}
				}
			}

			const e = new Error( "status" );
			e.isAborted = !!res.isAborted;
			e.rStatus = res.status;
			e.rData = await res.text();
			
			console.error( defMethod + " request to \"" + url + "\" is failed with status: " + e.rStatus + ", data: " + e.rData );

			//if error data text is json, trying to get errors from it
			if ( e.rData ) {
				try {
				  const t = JSON.parse( e.rData );
				  if ( t && Array.isArray( t.errors ) ) e.rData = t.errors.join( "; " );
				}
				catch ( et ) {}
      }

			if ( !e.isAborted && notify && app && app.$root && app.$root.$emit && ( res.status !== 401 && res.status !== 403 ) ) app.$root.$emit( "notify", { header: app.$t ? app.$t( "InvalidServerAnswer" ) : "invalid server answer", message: e.rData, type: "error" } );
			
			throw e;
		}
		
		switch ( defRet ) {
			case "json":
			return await res.json();
			
			case "text":
			return await res.text();
			
			default:
				throw new Error( `API method ${defRet} is not supported yet` );
		}
	},
	
	get: {
		async json( url, data, opts, cache, urlPreprocess ) {
			return await api.rq.call(
				api,
				"get",
				"application/json",
				"json",
				url,
				data,
				opts,
				cache,
				urlPreprocess
			);
		},
		
		async text( url, data, opts, cache, urlPreprocess ) {
			return await api.rq.call(
				api,
				"get",
				undefined,
				"text",
				url,
				data,
				opts,
				cache,
				urlPreprocess
			);
		}
	},
	
	post: {
		async json( url, data, opts, cache, urlPreprocess ) {
			return await api.rq.call(
				api,
				"post",
				"application/json",
				"json",
				url,
				data,
				opts,
				cache,
				urlPreprocess
			);
		},
		
		async text( url, data, opts, cache, urlPreprocess ) {
			return await api.rq.call(
				api,
				"post",
				undefined,
				"text",
				url,
				data,
				opts,
				cache,
				urlPreprocess
			);
		}
	},
	
	patch: {
		async json( url, data, opts, cache, urlPreprocess ) {
			return await api.rq.call(
				api,
				"patch",
				"application/json",
				"json",
				url,
				data,
				opts,
				cache,
				urlPreprocess
			);
		}
	},
	
	put: {
		async json( url, data, opts, cache, urlPreprocess ) {
			return await api.rq.call(
				api,
				"put",
				"application/json",
				"json",
				url,
				data,
				opts,
				cache,
				urlPreprocess
			);
		}
	},
	
	delete: {
		async json( url, data, opts, cache, urlPreprocess ) {
			return await api.rq.call(
				api,
				"delete",
				"application/json",
				"json",
				url,
				data,
				opts,
				cache,
				urlPreprocess
			);
		}
	},
  
  async allPostJson( handler, url, data, opts, cache, urlPreprocess, itemsPerPage ) {
	  if ( typeof( itemsPerPage ) != "number" || !itemsPerPage || itemsPerPage < 1 || itemsPerPage > 50 ) itemsPerPage = 50;
	  
	  data.itemsPerPage = itemsPerPage;
	  let page = 1;

	  while ( true ) {
  	  data.page = page;

      const ans = await this.post.json(
        url,
        data,
        opts,
        cache,
        urlPreprocess
      );
      
      if ( handler( ans, page, itemsPerPage ) === true ) break;

      page++;
    }
  }
};

export default api;
